// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3uJUU","header":"ReportDetails_header__bducv","title":"ReportDetails_title__21f-G","left":"ReportDetails_left__1BdD-"};